import React, { Component } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DayTarget from './DayTarget';
import SnackbarContent from '@material-ui/core/SnackbarContent';


class WeekBlock extends Component {

    calcDayValue = (week, day) => {
        return (7 * (week - 1)) + day
    }

    checkDetailDay = (week, day, lessons) => {
        return lessons.map(lesson => {
            if (lesson.WeekNum === week && lesson.DayOfWeek === day) {
                return (
                    <SnackbarContent style={{ backgroundColor: '#DDDDDD', maxWidth: '100%', minWidth: '90%', color: 'black' }} 
                        message={lesson.LessonName}
                    />
                )
            }
        })
    }

    render() {
        const { week, lessons, module_id } = this.props

        if (this.props.view_type === 'edit' || 'create') {
            return (
                <TableRow key={this.props.week}>
                    <TableCell style={{ margin: 0, padding: 5 }}><DayTarget key={week + '_' + 1} week={week} lessons={lessons} module_id={module_id} day={1} dayValue={this.calcDayValue(week, 1)} weekend={true} /></TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}><DayTarget key={week + '_' + 2} week={week} lessons={lessons} module_id={module_id} day={2} dayValue={this.calcDayValue(week, 2)} /></TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}><DayTarget key={week + '_' + 3} week={week} lessons={lessons} module_id={module_id} day={3} dayValue={this.calcDayValue(week, 3)} /></TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}><DayTarget key={week + '_' + 4} week={week} lessons={lessons} module_id={module_id} day={4} dayValue={this.calcDayValue(week, 4)} /></TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}><DayTarget key={week + '_' + 5} week={week} lessons={lessons} module_id={module_id} day={5} dayValue={this.calcDayValue(week, 5)} /></TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}><DayTarget key={week + '_' + 6} week={week} lessons={lessons} module_id={module_id} day={6} dayValue={this.calcDayValue(week, 6)} /></TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}><DayTarget key={week + '_' + 7} week={week} lessons={lessons} module_id={module_id} day={7} dayValue={this.calcDayValue(week, 7)} weekend={true} /></TableCell>
                </TableRow>
            )
        }
        else {
            return (
                <TableRow key={this.props.week}>
                    <TableCell style={{ margin: 0, padding: 5 }}>{this.checkDetailDay(week, 1, lessons)}</TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}>{this.checkDetailDay(week, 2, lessons)}</TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}>{this.checkDetailDay(week, 3, lessons)}</TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}>{this.checkDetailDay(week, 4, lessons)}</TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}>{this.checkDetailDay(week, 5, lessons)}</TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}>{this.checkDetailDay(week, 6, lessons)}</TableCell>
                    <TableCell style={{ margin: 0, padding: 5 }}>{this.checkDetailDay(week, 7, lessons)}</TableCell>
                </TableRow>
            )
        }
    }
}

export default WeekBlock;


// WEBPACK FOOTER //
// src/main/content/module/scheduleComponents/WeekBlock.js